import React from 'react';
import PropTypes from 'prop-types';

import OnDemandIcon from 'components/bookings/past/on-demand-icon';

const propTypes = {
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onDemand: PropTypes.bool,
};

const defaultProps = {
  disabled: false,
  selected: false,
  onDemand: false,
};

const PastBookingInfoToggle = ({ disabled, selected, onDemand }) => {
  if (onDemand) {
    return <OnDemandIcon onDemand className="display-inline-block text-size-36" />;
  }

  if (selected) {
    return <span className="chevron-down" />;
  }

  if (!disabled) {
    return <span className="chevron-right" />;
  }

  return null;
};

PastBookingInfoToggle.propTypes = propTypes;
PastBookingInfoToggle.defaultProps = defaultProps;
export default PastBookingInfoToggle;
